import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getNetworkOrdersSummary({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.networkOrders.summary, signal });
    yield put(actions.getNetworkOrdersSummaryDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getNetworkOrdersSummaryFailed,
      endpoint: api.networkOrders.summary.url
    });
  }
}

export const getNetworkOrdersSummarySaga = takeEvery(types.GET_NETWORK_ORDERS_SUMMARY_REQUEST, getNetworkOrdersSummary);
